import { StyleSheet } from 'react-native';

import { LAYOUT } from '../../../../../reactor/common';

export default StyleSheet.create({
  container: {
    ...LAYOUT.STYLE.CENTERED,
    position: 'absolute',
    left: 0,
    top: 0,
    overflow: 'hidden',
  },

  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
  },
});
